import { createContext, useContext } from "react"

// own context: a keystroke here must not re-render the whole resume tree
interface PhoneContextType {
    code: string
    rest: string
    show: boolean
    setCode: (value: string) => void
    setRest: (value: string) => void
    setShow: (show: boolean) => void
}

export const PhoneContext = createContext<PhoneContextType | undefined>(undefined)

export const usePhone = (): PhoneContextType => {
    const ctx = useContext(PhoneContext)
    if (!ctx) throw new Error("usePhone must be used within PhoneProvider")
    return ctx
}
